import { AppSettings } from '../../core/AppSettings';
import { Injectable } from '@angular/core';

@Injectable()
export class FrederiqueAppSettings extends AppSettings {
    constructor() {
        super();
        // Overwrite default settings specific for FREDERIQUE. Example below:
        this.MaximumDaysAllowedForWarrantyReturn = 730;
        this.PrePairedWarrantyCards = false;
        this.MaximumDaysForPastActivationDate = 730;
    }
}
